export default "/images/8c2ce8e30fd49b7971ae0b99e2149aa7.avif";